import { render, staticRenderFns } from "./addvatdiag.vue?vue&type=template&id=7f1d7904&scoped=true&"
import script from "./addvatdiag.vue?vue&type=script&lang=js&"
export * from "./addvatdiag.vue?vue&type=script&lang=js&"
import style0 from "./addvatdiag.vue?vue&type=style&index=0&id=7f1d7904&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d7904",
  null
  
)

export default component.exports